import HeaderLogo from '@/assets/logo_twm.png'
import { getImageSize, pixelToDxa, pixelToHalfPt } from '@/libs/utils/docxUtils'
import {
  BorderStyle,
  Document,
  Footer,
  Header,
  ImageRun,
  PageNumber,
  Paragraph,
  TextRun,
  TableOfContents,
} from 'docx'
import Chapter1Page from './Pages/PhishPro/Chapter1Page'
import Chapter2Page from './Pages/PhishPro/Chapter2Page'
import Chapter3Page from './Pages/PhishPro/Chapter3Page'
import Chapter3Sub1Page from './Pages/PhishPro/Chapter3Sub1Page'
import Chapter3Sub2Page from './Pages/PhishPro/Chapter3Sub2Page'
import Chapter4Page from './Pages/PhishPro/Chapter4Page'
import Chapter4Sub1Page from './Pages/PhishPro/Chapter4Sub1Page'
import Chapter4Sub2Page from './Pages/PhishPro/Chapter4Sub2Page'
import Chapter4Sub3Page from './Pages/PhishPro/Chapter4Sub3Page'
import Chapter4Sub4Page from './Pages/PhishPro/Chapter4Sub4Page'
import Chapter4Sub5Page from './Pages/PhishPro/Chapter4Sub5Page'
import Chapter4Sub6Page from './Pages/PhishPro/Chapter4Sub6Page'
import Chapter4Sub7Page from './Pages/PhishPro/Chapter4Sub7Page'
import Chapter4Sub8Page from './Pages/PhishPro/Chapter4Sub8Page'
import Chapter4Sub9Page from './Pages/PhishPro/Chapter4Sub9Page'
// import Chapter4Sub10Page from './Pages/PhishPro/Chapter4Sub10Page'
// import Chapter4Sub11Page from './Pages/PhishPro/Chapter4Sub11Page'
import Chapter5Page from './Pages/PhishPro/Chapter5Page'
import CoverPage from './Pages/PhishPro/CoverPage'
import DisclaimerPage from './Pages/PhishPro/DisclaimerPage'
import TableOfContentsPage from './Pages/PhishPro/TableOfContentsPage'

const generate = async ({
  donutChartImg,
  pieChartImg,
  pieChart2Img,
  barChart2Img,
  barChart3Img,
  barChart4Img,
  reportData,
}) => {
  const { reprotDao, secondaryCompanyFullname } = reportData || {}
  const { companyName } = reprotDao || {}

  // const shouldRenderOfficePage = reportData.officeReportGroups.length > 0
  const shouldRenderHistoriesPage = reportData.reprotHistories.length > 1

  const { width, height } = await getImageSize({ image: HeaderLogo, width: 125, height: 'auto' })
  const imgData = await (await fetch(HeaderLogo)).blob()

  const spaceLength = 120 // 預設的空白長度

  // 計算空白數量
  let spaceCount
  if (companyName.length <= 8) {
    spaceCount = spaceLength - companyName.length * 2 - 22
  } else {
    spaceCount = spaceLength - companyName.length * 2 - 28
  }

  // 計算空白數量
  let spaceCount2
  if (secondaryCompanyFullname.length <= 10) {
    spaceCount2 = spaceLength
  } else {
    spaceCount2 = spaceLength - secondaryCompanyFullname.length * 2
  }

  // 動態創建對應的空白
  const spaces = ' '.repeat(Math.max(0, spaceCount)) // 防止空白數量為負

  // 計算空白數量
  const spaces2 = ' '.repeat(Math.max(0, spaceCount2)) // 防止空白數量為負

  return new Document({
    features: {
      updateFields: true,
    },
    styles: {
      default: { document: { run: { size: pixelToHalfPt(20) } } },
      paragraphStyles: [
        {
          id: 'TOC1',
          name: 'toc 1',
          basedOn: 'Heading1',
          next: 'Heading1',
          quickFormat: true,
          run: {
            font: 'Noto Sans TC',
            color: '000000',
            size: 24,
            bold: true,
          },
          paragraph: {
            indent: {
              left: 360,
              right: 0,
              hanging: 360,
            },
          },
        },
        {
          id: 'TOC2',
          name: 'toc 2',
          basedOn: 'Heading2',
          next: 'Heading2',
          quickFormat: true,
          run: {
            font: 'Noto Sans TC',
            color: '000000',
            size: 24,
            bold: true,
          },
          paragraph: {
            indent: {
              left: 480,
            },
          },
        },
        {
          id: 'TOC3',
          name: 'toc 3',
          basedOn: 'Heading3',
          next: 'Heading3',
          quickFormat: true,
          run: {
            font: 'Noto Sans TC',
            color: '000000',
            size: 24,
            bold: true,
          },
          paragraph: {
            indent: {
              left: 960,
            },
          },
        },
        {
          id: 'textParagraph',
          name: 'Text Paragraph',
          basedOn: 'Normal',
          paragraph: { spacing: { line: pixelToDxa(20) } },
        },
        // {
        //   id: 'coverTitle',
        //   name: 'Cover Title',
        //   basedOn: 'Normal',
        //   run: { size: pixelToHalfPt(30), characterSpacing: 40 },
        // },
        // {
        //   id: 'coverSubtitle',
        //   name: 'Cover Subtitle',
        //   basedOn: 'Normal',
        //   run: { size: pixelToHalfPt(16), characterSpacing: 20 },
        // },
      ],

      // paragraphStyles: [
      //   {
      //     id: 'coverTitle',
      //     name: 'Cover Title',
      //     basedOn: 'Normal',
      //     run: { size: pixelToHalfPt(30), characterSpacing: 40, font: 'Calibri' },
      //   },
      //   {
      //     id: 'coverSubtitle',
      //     name: 'Cover Subtitle',
      //     basedOn: 'Normal',
      //     run: { size: pixelToHalfPt(16), characterSpacing: 20 },
      //   },
      //   {
      //     id: 'headerText',
      //     name: 'Header Text',
      //     basedOn: 'Normal',
      //     run: { size: pixelToHalfPt(22), bold: true },
      //   },
      //   {
      //     id: 'horizontalRule',
      //     name: 'Horizontal Rule',
      //     basedOn: 'Normal',
      //     run: { size: 1 },
      //   },
      //   {
      //     id: 'sectionHeader',
      //     name: 'Section Header',
      //     paragraph: {
      //       spacing: { before: pixelToDxa(40), after: pixelToDxa(40) },
      //     },
      //     run: { size: pixelToHalfPt(25), bold: true },
      //   },
      //   {
      //     id: 'textParagraph',
      //     name: 'Text Paragraph',
      //     basedOn: 'Normal',
      //     paragraph: { spacing: { line: pixelToDxa(50) }, indent: { left: pixelToDxa(30) } },
      //   },
      //   {
      //     id: 'textParagraphIndent',
      //     name: 'Text Paragraph Indent',
      //     basedOn: 'Normal',
      //     paragraph: { spacing: { line: pixelToDxa(50) }, indent: { firstLine: pixelToDxa(30) } },
      //   },
      //   {
      //     id: 'default',
      //     name: 'Default',
      //     basedOn: 'Normal',
      //     run: { size: pixelToHalfPt(20) },
      //   },
      // ],
    },
    sections: [
      {
        properties: {
          titlePage: true,
          page: {
            size: { height: '297mm', width: '210mm' },
            pageNumbers: { start: 0 },
            margin: { left: pixelToDxa(100), right: pixelToDxa(100), headers: 1000, footer: 950 },
          },
        },
        headers: {
          default: new Header({
            children: [
              new Paragraph({
                // style: 'textParagraph',
                children: [
                  new ImageRun({
                    data: imgData, // 使用公司 Logo 圖片
                    transformation: {
                      width,
                      height,
                    },
                  }),
                  new TextRun({
                    text: spaces,
                  }),
                  new TextRun({
                    text: '社交工程演練結果報告 – ',
                    font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                    size: 20,
                  }),
                  new TextRun({
                    text: companyName,
                    font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                    size: 20,
                  }),
                ],
              }),
              new Paragraph({
                border: {
                  bottom: {
                    color: '#A9A9A9',
                    style: BorderStyle.SINGLE,
                    size: 2, // 控制橫線的粗細
                  },
                },
              }),
            ],
          }),
        },
        footers: {
          default: new Footer({
            children: [
              new Paragraph({
                border: {
                  top: {
                    color: '#A9A9A9',
                    style: BorderStyle.SINGLE,
                    size: 2, // 控制橫線的粗細
                  },
                },
              }),
              new Paragraph({
                style: 'textParagraph',
                children: [
                  new TextRun({
                    text: '本文件之智慧財產權屬',
                    font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                    size: 20,
                  }),
                  new TextRun({
                    text: secondaryCompanyFullname,
                    font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                    size: 20,
                  }),
                  new TextRun({
                    text: spaces2,
                  }),
                  new TextRun({ children: [PageNumber.CURRENT], size: 22 }),
                ],
              }),
            ],
          }),
        },
        children: [
          ...(await CoverPage({ reportData })),
          ...DisclaimerPage({ reportData }),
          ...TableOfContentsPage(),
          new TableOfContents('Summary', {
            hyperlink: true,
            headingStyleRange: '1-5',
          }),
          ...Chapter1Page({ reportData }),
          ...Chapter2Page({ reportData }),
          ...Chapter3Page({ reportData }),
          ...Chapter3Sub1Page({ reportData }),
          ...Chapter3Sub2Page({ reportData }),
          ...Chapter4Page({ reportData }),
          ...(await Chapter4Sub1Page({ donutChartImg })),
          ...Chapter4Sub2Page({ reportData }),
          ...(await Chapter4Sub3Page({ barChart3Img })),
          ...(await Chapter4Sub4Page({ barChart4Img, reportData })),
          ...Chapter4Sub5Page({ reportData }),
          // ...(shouldRenderOfficePage ? await Chapter4Sub6Page({ pieChartImg, reportData }) : []),
          // ...(await Chapter4Sub7Page({ pieChart2Img, reportData, shouldRenderOfficePage })),
          ...(shouldRenderHistoriesPage ? Chapter4Sub8Page({ reportData }) : []),
          ...(shouldRenderHistoriesPage ? await Chapter4Sub9Page({ barChart2Img }) : []),
          // ...Chapter4Sub10Page({ reportData, shouldRenderOfficePage }),
          // ...Chapter4Sub11Page({ reportData, shouldRenderOfficePage }),
          ...Chapter5Page({ reportData }),
        ],
      },
    ],
    updateFields: true, // 啟用自動更新頁碼
  })
}

export { generate }
